import { http } from '@/core/api/';

const apiUrl = 'api/academicyears';
export default {
  async getReferralServiceAcademicYears() {
    return await http.get(`${apiUrl}/getreferralserviceacademicyears`);
  },
  async getReferralAppointment() {
    return await http.get(`${apiUrl}/referralappointment`);
  },
  async getAvailableMonths(academicYearId) {
    return await http.get(`${apiUrl}/${academicYearId}/months`);
  },
  async getEffectiveAcademyYears(admissionId) {
    return await http.get(`${apiUrl}/effectiveacademicyears/${admissionId}`);
  },
  async getAcademicYearForDate(date) {
    return await http.get(`${apiUrl}/getacademicyearfordate`, {
      params: { date: date },
    });
  },
  async getAcademicYearFromMin(params) {
    return await http.get(`${apiUrl}/academicyearfromin`, {
      params,
    });
  },
  async getAcademicYearToFuture() {
    return await http.get(`${apiUrl}`);
  },
  async getAcademicYearsToCurrentYear() {
    return await http.get(`${apiUrl}/getacademicyearstocurrentyear`);
  },
  async getAcademicYearsToFutureYear() {
    return await http.get(`${apiUrl}/getacademicyearstofutureyear`);
  },
  async getAcademicYearFromIntoType() {
    return await http.get(`${apiUrl}/academicyearfromintotype`);
  },
  async getCurrentAcademicYear() {
    return await http.get(`${apiUrl}/current`);
  },
  async getPreviousAcademicYear() {
    return await http.get(`${apiUrl}/previous`);
  },
  async getAcademicYearById(academicYearId) {
    return await http.get(`${apiUrl}/getacademicyearbyid/${academicYearId}`);
  },
};
